module.exports = __webpack_public_path__ + "static/media/casem-branco.03c1758e.png";